import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';

const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getShippingMethodListAPI = async (token) => {
    try {
        const response = await API.get('admin/shipping-method', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

export const createShippingMethodAPI = async (formData, token) => {
    try {
        const response = await API.post('admin/shipping-method/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const getShippingAPI = async (id, token) => {
    try {
        const response = await API.get(`admin/shipping-method/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const updateShippingAPI = async (formData, id, token) => {
    try {
        const response = await API.post(`admin/shipping-method/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteShippingMethodAPI = async (id, token) => {
    try {
        const response = await API.get(`admin/shipping-method/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const getRegionListAPI = async (token) => {
    try {
        const response = await API.get('admin/regions', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

export const getShippingZoneListAPI = async (token) => {
    try {
        const response = await API.get('admin/shipping-zone', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

export const createShippingZoneAPI = async (formData, token) => {
    try {
        const response = await API.post('admin/shipping-zone/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const getShippingZoneAPI = async (id, token) => {
    try {
        const response = await API.get(`admin/shipping-zone/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const updateShippingZoneAPI = async (formData, id, token) => {
    try {
        const response = await API.post(`admin/shipping-zone/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteShippingZoneAPI = async (id, token) => {
    try {
        const response = await API.get(`admin/shipping-zone/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const getShippingRateListAPI = async (token) => {
    try {
        const response = await API.get('admin/shipping-rate', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

export const createShippingRateAPI = async (formData, token) => {
    try {
        const response = await API.post('admin/shipping-rate/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const getShippingRateAPI = async (id, token) => {
    try {
        const response = await API.get(`admin/shipping-rate/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const updateShippingRateAPI = async (formData, id, token) => {
    try {
        const response = await API.post(`admin/shipping-rate/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteShippingRateAPI = async (id, token) => {
    try {
        const response = await API.get(`admin/shipping-rate/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};